import React, { useState, useEffect, useRef } from "react";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminCustomURLCopy from "../../../components/CommonComponents/AdminCustomURLCopy";
import { toast } from "react-toastify";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function ImageSettings() {
  const { fetchRequest, globalImageUplaodAPI } = useMyContext()
  const [editUser, setEditUser] = useState({
    compress_resolution_size: '',
    compress_resolution_format: '',
    enable_multiple_compress_image: '',
    enable_compress_image: '',
    audios: '',
    episode: '',
    season: '',
    series: '',
    live: '',
    videos: '',
    disable_image_ratio_validation: '',
    enable_top_ten_image: 1,
  });
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [formDataError, setFormDataError] = useState({})
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);
  const [topTenImages, setTopTenImages] = useState([]);

  // ── Per-slot upload state ────────────────────────────────────────────────────
  // { [filename]: File }
  const [slotFiles, setSlotFiles] = useState({});
  // { [filename]: string } — dimension error per slot
  const [slotErrors, setSlotErrors] = useState({});
  // { [filename]: bool }
  const [slotUploading, setSlotUploading] = useState({});
  // { [filename]: string } — local preview data URL
  const [slotPreviews, setSlotPreviews] = useState({});
  // { [filename]: number } — cache-bust timestamp set after successful upload
  const [cacheBusters, setCacheBusters] = useState({});

  const combinedRef = useRef({
    compress_resolution_size: null,
    compress_resolution_format: null,
  });

  const handleInput = async (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setEditUser((prev) => ({
        ...prev,
        [name]: checked ? 1 : 0,
      }));
    }
    if (type === 'text' || type == 'number') {
      setEditUser((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
    if (type === 'select-one') {
      setEditUser((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }

  }

  // ── Per-slot upload handlers ────────────────────────────────────────────────
  const doUpload = async (filename, file) => {
    if (!file) return;
    setSlotUploading((prev) => ({ ...prev, [filename]: true }));
    try {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('targetFilename', filename);
      formData.append('modelName', 'TopTenImages');
      const response = await fetchRequest({
        method: 'POST',
        url: globalImageUplaodAPI(),
        params: {},
        data: formData,
      });
      if (response?.status) {
        toast.success(response?.message || 'Image uploaded successfully');
        setCacheBusters((prev) => ({ ...prev, [filename]: Date.now() }));
        setSlotFiles((prev) => { const n = { ...prev }; delete n[filename]; return n; });
        setSlotPreviews((prev) => { const n = { ...prev }; delete n[filename]; return n; });
        setSlotErrors((prev) => { const n = { ...prev }; delete n[filename]; return n; });
        setWithOutRefresh((prev) => !prev);
      } else {
        toast.error(response?.message || 'Upload failed');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || 'Upload failed');
    } finally {
      setSlotUploading((prev) => ({ ...prev, [filename]: false }));
    }
  };

  const handleSlotFileSelect = (filename, file) => {
    if (!file) return;
    setSlotErrors((prev) => ({ ...prev, [filename]: '' }));
    setSlotFiles((prev) => ({ ...prev, [filename]: file }));

    const reader = new FileReader();
    reader.onload = (ev) => {
      const dataUrl = ev.target.result;
      setSlotPreviews((prev) => ({ ...prev, [filename]: dataUrl }));

      const ref = topTenImages.find((img) => img.filename !== filename && img.width && img.height);
      if (ref) {
        const img = new Image();
        img.onload = () => {
          if (img.width !== ref.width || img.height !== ref.height) {
            setSlotErrors((prev) => ({
              ...prev,
              [filename]: `Required: ${ref.width} × ${ref.height} px — your image is ${img.width} × ${img.height} px.`,
            }));
          } else {
            doUpload(filename, file);
          }
        };
        img.src = dataUrl;
      } else {
        doUpload(filename, file);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleSlotUpload = async (img) => {
    const filename = img.filename;
    const file = slotFiles[filename];
    if (!file || slotErrors[filename]) return;
    doUpload(filename, file);
  };

  const handleSlotClear = (filename) => {
    setSlotFiles((prev) => { const n = { ...prev }; delete n[filename]; return n; });
    setSlotPreviews((prev) => { const n = { ...prev }; delete n[filename]; return n; });
    setSlotErrors((prev) => { const n = { ...prev }; delete n[filename]; return n; });
  };

  const formValidation = () => {
    let formIsValid = true;
    if (!editUser?.compress_resolution_size) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        compress_resolution_size: "Compress resolution  cannot be empty.",
      }));
      combinedRef.current['compress_resolution_size'].focus()
      formIsValid = false;
    }
    if (!editUser?.compress_resolution_format) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        compress_resolution_format: "Compress image format cannot be empty.",
      }));
      combinedRef.current['compress_resolution_format'].focus()
      formIsValid = false;
    }
    return formIsValid;
  }
  const handleUpdate = async (e) => {
    if (formValidation()) {
      setShowOverlay(true)
      const formDataAdd = {};
      for (const key in editUser) {
        if (["videos", "live", "series", "season", "episode", "audios", "enable_compress_image", "enable_multiple_compress_image", "compress_resolution_format", "compress_resolution_size", "disable_image_ratio_validation", "enable_top_ten_image"].includes(key)) {
          formDataAdd[key] = editUser[key]
        }
      }
      await fetchRequest({
        method: 'POST',
        url: `${process.env.REACT_APP_Baseurl}/admin/compress_image_store`,
        params: {},
        data: { ...formDataAdd },
      })
        .then(response => {
          if (response?.status) {
            toast.success(response?.message)
            setWithOutRefresh((prev) => !prev)
            setShowOverlay(false)
          }
        }).catch((error => {
          toast.success(error?.response?.message)
          setShowOverlay(false)

        }))
    }
    else {
      console.log("Validation failed")
    }
  };

  useEffect(async () => {
    await fetchRequest({
      method: 'GET',
      url: `${process.env.REACT_APP_Baseurl}/admin/compress_image`,
      params: {},
      data: {},
    })
      .then(response => {
        if (response?.status) {
          setEditUser((prev) => ({
            ...prev,
            ...response.Compress_image,
            enable_top_ten_image: response.Compress_image?.enable_top_ten_image ?? 1,
            compressOption: response?.compress_resolution_format,
          }));
          if (Array.isArray(response?.topTenImages)) {
            setTopTenImages(response.topTenImages);
          }
        }
      }).catch((error => {
        console.error(error)
      }))
  }, [withOutRefresh]);

  useEffect(async () => {
    await fetchRequest({
      method: 'GET',
      url: `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
      params: { source: 'compress-image-settings' },
      data: {},
    })
      .then(response => {
        if (response?.status) {
          const result = response?.label_management
          setLabelDisplay(result)
        }
      }).catch((error => {
        console.error(error)
      }))
  }, [])

  return (
    <>
      {showOverlay && (<Response_Processing />)}

      <AdminSaveHeader heading={labelDisplay?.[0]?.title} saveText={labelDisplay?.[0]?.sub_title} saveMethod={handleUpdate} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[1]?.sub_title} />
            <MessageLabel text={labelDisplay?.[1]?.title} className="mandatorySimple" />
            <AdminCustomInput type="number" name="compress_resolution_size" value={editUser?.compress_resolution_size} onChange={handleInput} placeHolder={"Please enter a number compress size"} ref={(el) => (combinedRef.current.compress_resolution_size = el)} error={formDataError?.compress_resolution_size} />
            <MessageLabel text={labelDisplay?.[2]?.title} />
            <AdminCustomSelect name="compress_resolution_format" value={editUser?.compress_resolution_format} onChange={handleInput} ref={(el) => (combinedRef.current.compress_resolution_format = el)} options={editUser?.compressOption?.map((item, index) => ({ name: item.name, value: item.format }))} error={formDataError?.compress_resolution_format} defaultOptionName={"Choose an format"} />
          </Wrapper>

          {/* ── Top Ten Images ─────────────────────────────────── */}
          <Wrapper>
            <MessageHeading text={"Top Ten Images"} />

            {/* Toggle */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <MessageLabel text={"Enable Top Ten Images"} />
              <AdminSwitch
                name={'enable_top_ten_image'}
                checked={editUser?.enable_top_ten_image}
                onChange={handleInput}
              />
            </div>

            {/* ── Per-slot image list with individual upload zones ─────── */}
            {topTenImages.length === 0 ? (
              <p className="theme-text-color opacity-50 text-center py-3" style={{ fontSize: '13px' }}>
                No images found in TopTenImages folder.
              </p>
            ) : (
              <div className="d-flex flex-column gap-4">
                {topTenImages.map((img) => {
                  const hasNewFile = !!slotFiles[img.filename];
                  const dimError = slotErrors[img.filename];
                  const preview = slotPreviews[img.filename];
                  const uploading = !!slotUploading[img.filename];

                  return (
                    <div key={img.filename}>
                      {/* Label row */}
                      <MessageLabel text={`#${img.index} — ${img.filename}`} />
                      {img.width && img.height && (
                        <p className="theme-text-color mb-2" style={{ fontSize: '12px', opacity: 0.55 }}>
                          Required size: {img.width} × {img.height} px
                        </p>
                      )}

                      {/* Row: all 3 items are direct siblings — layout never breaks when file is selected */}
                      <div className="d-flex align-items-center gap-3 flex-wrap">

                        {/* 1. Current saved image */}
                        {img.url && (
                          <div
                            className="rounded-2 overflow-hidden flex-shrink-0"
                            style={{ width: '90px', height: '100px', background: 'rgba(0,0,0,0.08)', border: '1px solid rgba(0,0,0,0.12)' }}
                          >
                            <img
                              src={cacheBusters[img.filename] ? `${img.url}?t=${cacheBusters[img.filename]}` : img.url}
                              alt={`Top ${img.index}`}
                              style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
                              onError={(e) => { e.target.style.display = 'none'; }}
                            />
                          </div>
                        )}

                        {/* 2. New file preview — only when a file is selected */}
                        {hasNewFile && preview && (
                          <div className="position-relative flex-shrink-0">
                            <img
                              src={preview}
                              alt="new"
                              className="rounded-2"
                              style={{ width: '90px', height: '100px', objectFit: 'cover', border: '1px solid rgba(0,0,0,0.15)', display: 'block' }}
                            />
                            <button
                              type="button"
                              className="btn-close position-absolute top-0 end-0 rounded-circle opacity-1 shadow theme-bg-color"
                              style={{ width: '20px', height: '20px', margin: '4px' }}
                              onClick={() => handleSlotClear(img.filename)}
                            />
                          </div>
                        )}

                        {/* 3. Upload drop zone */}
                        <label
                          htmlFor={`topten-upload-${img.filename}`}
                          className="imagedrop ImageUploadContainer rounded-2 d-flex align-items-center justify-content-center flex-shrink-0"
                          style={{ width: '90px', height: '100px', border: '2px dashed rgba(0,0,0,0.2)', cursor: 'pointer', position: 'relative' }}
                        >
                          <input
                            id={`topten-upload-${img.filename}`}
                            type="file"
                            accept="image/png,image/jpeg,image/jpg,image/webp"
                            style={{ opacity: 0, position: 'absolute', inset: 0, width: '100%', height: '100%', cursor: 'pointer' }}
                            onChange={(e) => {
                              const f = e.target.files[0];
                              if (f) handleSlotFileSelect(img.filename, f);
                              e.target.value = '';
                            }}
                          />
                          <svg width="24" height="24" fill="none" stroke="#6c757d" strokeWidth="1.5" viewBox="0 0 24 24">
                            <rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="M21 15l-5-5L5 21" />
                          </svg>
                        </label>

                      </div>

                      {/* Dimension error */}
                      {dimError && (
                        <p className="text-danger mt-1 mb-0" style={{ fontSize: '12px' }}>{dimError}</p>
                      )}

                      {/* URL copy — full width below the row */}
                      {img.url && (
                        <AdminCustomURLCopy link={cacheBusters[img.filename] ? `${img.url}?t=${cacheBusters[img.filename]}` : img.url} className="copy-board-input" labelClassName="mt-md-2" />
                      )}

                      {/* Upload button */}
                      {hasNewFile && !dimError && (
                        <button
                          type="button"
                          className="theme-button-bg-color theme-button-text-color border-0 rounded-2 px-4 py-2 mt-2"
                          style={{ fontSize: '13px', fontWeight: 600, cursor: uploading ? 'not-allowed' : 'pointer', opacity: uploading ? 0.7 : 1 }}
                          onClick={() => handleSlotUpload(img)}
                          disabled={uploading}
                        >
                          {uploading ? 'Uploading…' : 'Save Image'}
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[3]?.title} />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[4]?.title} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'enable_compress_image'} checked={editUser?.enable_compress_image} onChange={handleInput} />
              </div>
            </div>
            {/* <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[6]?.title} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'enable_multiple_compress_image'} checked={editUser?.enable_multiple_compress_image} onChange={handleInput} />
              </div>
            </div> */}
          </Wrapper>

          <Wrapper>
            <MessageHeading text={"Image Validation"} />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Enable Videos"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'videos'} checked={editUser?.videos} onChange={handleInput} />
              </div>
            </div>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Enable Live Videos"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'live'} checked={editUser?.live} onChange={handleInput} />
              </div>
            </div>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Enable Series"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'series'} checked={editUser?.series} onChange={handleInput} />
              </div>
            </div>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Enable Season"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'season'} checked={editUser?.season} onChange={handleInput} />
              </div>
            </div>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Enable Episode"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'episode'} checked={editUser?.episode} onChange={handleInput} />
              </div>
            </div>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Enable Audio"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'audios'} checked={editUser?.audios} onChange={handleInput} />
              </div>
            </div>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Disable Ratio Validation"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'disable_image_ratio_validation'} checked={editUser?.disable_image_ratio_validation} onChange={handleInput} />
              </div>
            </div>
          </Wrapper>
        </RightWrapper>
      </FormContainer>
    </>
  );
}

export default ImageSettings;